module.exports = __webpack_public_path__ + "img/green.0b353a97.png";